export default __webpack_public_path__ + "static/media/please-wait-anime.b21faa5b.gif";